import { useState } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface LessonRatingProps {
  onRate: (rating: number, emoji: string) => void;
  existingRating?: number;
  disabled?: boolean;
}

const EMOJIS = [
  { rating: 1, emoji: "😞", label: "لم يعجبني", color: "text-red-500" },
  { rating: 2, emoji: "😐", label: "عادي", color: "text-orange-500" },
  { rating: 3, emoji: "🙂", label: "جيد", color: "text-yellow-500" },
  { rating: 4, emoji: "😊", label: "ممتاز", color: "text-green-500" },
  { rating: 5, emoji: "🤩", label: "رائع جداً!", color: "text-primary" },
];

const LessonRating = ({ onRate, existingRating, disabled }: LessonRatingProps) => {
  const [selected, setSelected] = useState<number | null>(existingRating || null);
  const [submitted, setSubmitted] = useState(!!existingRating);

  const handleSelect = (rating: number, emoji: string) => {
    if (disabled || submitted) return;
    setSelected(rating);
    setSubmitted(true);
    onRate(rating, emoji);
  };

  return (
    <div className="text-center space-y-3">
      <p className="text-sm font-semibold text-foreground">كيف وجدت هذا الدرس؟</p>
      <div className="flex items-center justify-center gap-3">
        {EMOJIS.map((e) => (
          <motion.button
            key={e.rating}
            whileHover={!submitted ? { scale: 1.2 } : {}}
            whileTap={!submitted ? { scale: 0.9 } : {}}
            onClick={() => handleSelect(e.rating, e.emoji)}
            disabled={disabled || submitted}
            className={cn(
              "flex flex-col items-center gap-1 p-2 rounded-xl transition-all",
              selected === e.rating && "bg-primary/10 ring-2 ring-primary",
              submitted && selected !== e.rating && "opacity-30",
              !submitted && "hover:bg-muted/50 cursor-pointer"
            )}
          >
            <span className="text-3xl">{e.emoji}</span>
            <span className="text-[10px] text-muted-foreground">{e.label}</span>
          </motion.button>
        ))}
      </div>
      {submitted && selected && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-sm text-primary font-medium"
        >
          شكراً على تقييمك! ⭐
        </motion.p>
      )}
    </div>
  );
};

export default LessonRating;
